const areNumberArraysEqual = (a: number[] | undefined | null, b: number[] | undefined | null) => {
    return Array.isArray(a)
        && Array.isArray(b)
        && a.length === b.length
        && a.every((val, index) => val === b[index]);
}

export {
    areNumberArraysEqual
}
